import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'

import { IOption, IStateAndCountiesOptionsResponse } from '../../../common/common.types'
import { OptionsService } from '../../options/services/options.service'
import { PickupAddressConstants } from '../store/pickupAddress.constants'

import { IHomeState } from '../../../features/home/store/home.types'
import { IPickupAddressState } from '../store/pickupAddress.types'
import { IDispositionState } from '../../destinationAddress/store/destinationAddress.types'

import { getHomeSelector } from '../../../features/home/selectors/getHome.selector'
import { getPickupAddressSelector } from '../selectors'
import { getDestinationAddressSelector } from '../../destinationAddress/selectors/destinationAddress.selectors'

import { setPickUpAndDestinationCountyOptions } from '../../options/store/options.actions'

export function* getCountyOptionsForPickUpAndDestination() {
  try {
    const serviceId: string = yield select(getServiceIdSelector)
    const optionsService = new OptionsService(serviceId)

    let state: IOption | null = null

    const home: IHomeState = yield select(getHomeSelector)
    const { addressTypeSelected } = home

    if (addressTypeSelected === 1) {
      const pickupAddress: IPickupAddressState = yield select(getPickupAddressSelector)
      state = pickupAddress.state
    } else if (addressTypeSelected === 2) {
      const disposition: IDispositionState = yield select(getDestinationAddressSelector)
      state = disposition.destination.state
    }

    const response: IStateAndCountiesOptionsResponse = yield call([optionsService, optionsService.getCountyOptions])
    const { entity } = response

    const foundCountyObject = entity.find((obj) => obj.state === String(state?.id))
    const countiesToSet = foundCountyObject ? foundCountyObject.counties : []

    yield put(setPickUpAndDestinationCountyOptions(countiesToSet))
  } catch (e) {
    yield put(throwPcrException(`getCountyOptionsForPickUpAndDestination() error: ${e}`))
  }
}

export function* getCountyOptionsForPickUpAndDestinationSaga() {
  yield takeLatest([PickupAddressConstants.GET_COUNTY_OPTIONS], getCountyOptionsForPickUpAndDestination)
}
